import {
  FETCH_EXPENSES,
  FETCH_EXPENSES_SUCCESS,
  SHOW_EXPENSES_LOADER,
  SHOW_EXPENSES_MESSAGE,
  HIDE_EXPENSES_MESSAGE,
  ON_SAVE_EXPENSES,
  ON_EDIT_EXPENSES,
  SAVE_EXPENSES_SUCCESS,
  CHANGE_STATE_NEW_EXPENSES,
  DELETE_EXPENSES
} from 'constants/ActionTypes';


export const fetchExpenses = (from, to, page, limit, lastEvaluatedKey) => {
  return {
    type: FETCH_EXPENSES,
    payload: { from, to, page, limit, lastEvaluatedKey }
  };
};
export const fetchExpensesSuccess = (data) => {
  return {
    type: FETCH_EXPENSES_SUCCESS,
    payload: data
  }
};
export const showExpensesLoader = (data) => {
  return {
    type: SHOW_EXPENSES_LOADER,
    payload: data
  }
};
export const showExpensesMessage = (message, messageStatus = false) => {
  return {
    type: SHOW_EXPENSES_MESSAGE,
    payload: { message, messageStatus }
  };
};
export const hideExpensesMessage = () => {
  return {
    type: HIDE_EXPENSES_MESSAGE
  };
};
export const onSaveExpenses = (data) => {
  return {
    type: ON_SAVE_EXPENSES,
    payload: data
  };
};
export const onEditExpenses = (data) => {
  return {
    type: ON_EDIT_EXPENSES,
    payload: data
  };
};
export const saveExpensesSuccess = (data) => {
  return {
    type: SAVE_EXPENSES_SUCCESS,
    payload: data
  };
};
export const onDeleteExpenses = (id) => {
  return {
    type: DELETE_EXPENSES,
    payload: id
  };
};
export const changeStateNewExpenses = () => {
  return {
    type: CHANGE_STATE_NEW_EXPENSES
  };
};




// WEBPACK FOOTER //
// ./actions/Expenses.js